<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="4">
        <el-input
          placeholder="操作人查询"
          v-model="params.user_name"
          prefix-icon="el-icon-search"
          clearable
          @change="onSearch"/>
      </el-col>
      <el-col :span="4">
        <el-cascader
          ref="cascader"
          style="width: 100%;"
          clearable
          filterable
          placeholder="操作模块查询"
          separator="-"
          @change="moduleLogChange"
          :options="moduleLogList"
          :props="{
            label: 'text',
            value: 'text',
            children:'child',
            checkStrictly: true
          }"/>
      </el-col>
      <el-col :span="4">
        <el-select v-model="params.operate_type" placeholder="操作内容查询" @change="onSearch" clearable filterable style="width: 100%;">
          <el-option
            v-for="(it, index) in operation"
            :key="index"
            :label="it"
            :value="it">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import Util from '@/api/util'
import BasicDataHelper from '@/api/basic_data_helper'

export default {
  data () {
    return Backend.initListPage(this, 'user_operation_log', {
      route_name: '平台操作记录列表',
      moduleLogList: BasicDataHelper.moduleLogList,
      operation: [],
      params: {
        user_name: '',
        operate_type: '',
        module: '',
        max_results: 10
      },
      tableColList: [
        {
          key: 'creation_time',
          name: '操作时间',
          sortable: true
        },
        {
          key: 'user_name',
          name: '操作人'
        },
        {
          key: 'module',
          name: '操作模块'
        },
        {
          key: 'operate_type',
          name: '操作内容'
        }
      ]
    })
  },
  methods: {
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    moduleLogChange (val) {
      this.params.module = val.join('-')
      this.params.operate_type = ''

      const { data = {} } = this.$refs.cascader.getCheckedNodes()[0] || {}

      if (data.child) {
        const operation = []
        data.child.forEach(item => {
          if (item.operation) operation.push(...item.operation)
          this.operation = operation
        })
      } else {
        this.operation = data.operation || []
      }
      this.$refs.cascader.dropDownVisible = false
      this.onSearch()
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    }
  }
}
</script>
